<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Update"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Tax Setting
            </h4>
            <p class="category font-weight-thin">
              Update Tax Setting
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form
        v-if="dialog && !loading"
      >
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                v-model="localTax.name"
                v-validate="'required'"
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="localTax.percentage"
                v-validate="'required|min_value:0'"
                type="number"
                suffix="%"
                label="Percentage (%)"
                :error-messages="errors.collect('percentage')"
                data-vv-name="percentage"
                @change="percentage = parseFloat(localTax.percentage).toFixed(2)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>Is the tax still valid?</span>
              <v-radio-group
                v-model="localTax.is_valid"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                />
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              update
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      tax: {
        type: Object,
        default: null,
      },
    },

    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
        localTax: null,
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$validator.pause()
          this.$resetData()
        } else {
          this.localTax = { ...this.tax }
          this.$validator.resume()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.taxSettings().update(this.localTax.id, this.prepareFormData())
              .then((response) => {
                if (response.status === 200) {
                  this.$emit('updated')                
                  this.$snack({ color: 'success', message: response.data.status })

                  this.dialog = false                
                }
              }).catch(err => {
                console.log(err)
                this.$snack({ color: 'error', message: err.response.statusText })
              }).then(() => {
                this.dialog = false
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.localTax.name,
          percentage: this.localTax.percentage,
          is_valid: this.localTax.is_valid,
        }
      },
    },
  }
</script>
<style>
  .overflow {
    height: 60vh;
    overflow-x: hidden;
  }

  .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
    background-image: linear-gradient( grey , grey);
  }
</style>
